import { ContactUs } from 'containers/Contact'

export default ContactUs
